module.exports = __webpack_public_path__ + "img/img-presentation-story-big.ba123b93.png";